import { useLanguageData } from '@/common/hooks/useLanguageData';
import styled from 'styled-components';
import VioletCheckIcon from '../icons/violet-check.svg';

const Container = styled.div`
	font-family: 'Lato';
	color: white;
	padding: 0 5px;
	background-color: #4322c6;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 4px;
	font-size: 12px;
	margin-top: 5px;
	cursor: pointer;
`;

const CheckIcon = styled.img`
	width: 15px;
`;

type Props = { current: number; total: number; onClick: () => void };

function TaskStatus({ current, onClick, total }: Props) {
	const langData = useLanguageData('features.sceneV3');

	return (
		<Container onClick={onClick}>
			<CheckIcon src={VioletCheckIcon} />
			<div>{langData.tasks}:</div>
			<div>
				{current}/{total}
			</div>
		</Container>
	);
}

export default TaskStatus;
